var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 32,
    viewBox: "0 0 84 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6875 20.7851L20.5419 10.5424C20.3067 10.1504 19.8092 10.0055 19.4003 10.21L18.6571 10.5816C18.4886 10.6658 18.2852 10.6328 18.152 10.4996L14.6861 7.03363C14.3192 6.66673 13.7154 6.69791 13.3882 7.10057L4.375 18.1601V20.7851H26.6875Z",
    fill: "#DBEAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.657 10.5817C18.4886 10.6659 18.2851 10.6329 18.152 10.4997L18.0222 10.3699L15.0117 20.6624L15.4317 20.7852H15.8876L18.909 10.4557L18.657 10.5817Z",
    fill: "#C3DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.2226L14.3866 6.83738C14.0441 6.70334 13.6366 6.79489 13.3882 7.10054L4.375 18.1601V20.7851H10.5V14.2226Z",
    fill: "#C3DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6871 12.5238C13.3631 12.2421 12.8826 12.237 12.5527 12.5119L10.5 14.2226L8.05826 13.1761C7.69256 13.0193 7.26715 13.1291 7.02291 13.4431L1.3125 20.7851H23.1875L13.6871 12.5238Z",
    fill: "#C3DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05826 13.176C7.69256 13.0193 7.26715 13.1291 7.02291 13.4431L1.3125 20.785H13.5625L10.5 14.2225L8.05826 13.176Z",
    fill: "#A4CCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05826 13.176C7.69256 13.0193 7.26715 13.1291 7.02291 13.4431L1.3125 20.785H4.8125L8.85095 13.5158L8.05826 13.176Z",
    fill: "#8BB3EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5625 21.2227H0.4375C0.195672 21.2227 0 21.0268 0 20.7852C0 20.5435 0.195672 20.3477 0.4375 20.3477H27.5625C27.8043 20.3477 28 20.5435 28 20.7852C28 21.0268 27.8043 21.2227 27.5625 21.2227Z",
    fill: "#C3DDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 20.7851L48.5419 10.5424C48.3067 10.1504 47.8092 10.0055 47.4003 10.21L46.6571 10.5816C46.4886 10.6658 46.2852 10.6328 46.152 10.4996L42.6861 7.03363C42.3192 6.66673 41.7154 6.69791 41.3882 7.10057L32.375 18.1601V20.7851H54.6875Z",
    fill: "#DBEAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.657 10.5817C46.4886 10.6659 46.2851 10.6329 46.152 10.4997L46.0222 10.3699L43.0117 20.6624L43.4317 20.7852H43.8876L46.909 10.4557L46.657 10.5817Z",
    fill: "#C3DDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 14.2226L42.3866 6.83738C42.0441 6.70334 41.6366 6.79489 41.3882 7.10054L32.375 18.1601V20.7851H38.5V14.2226Z",
    fill: "#C3DDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6871 12.5238C41.3631 12.2421 40.8826 12.237 40.5527 12.5119L38.5 14.2226L36.0583 13.1761C35.6926 13.0193 35.2671 13.1291 35.0229 13.4431L29.3125 20.7851H51.1875L41.6871 12.5238Z",
    fill: "#C3DDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0583 13.176C35.6926 13.0193 35.2671 13.1291 35.0229 13.4431L29.3125 20.785H41.5625L38.5 14.2225L36.0583 13.176Z",
    fill: "#A4CCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0583 13.176C35.6926 13.0193 35.2671 13.1291 35.0229 13.4431L29.3125 20.785H32.8125L36.851 13.5158L36.0583 13.176Z",
    fill: "#8BB3EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5625 21.2227H28.4375C28.1957 21.2227 28 21.0268 28 20.7852C28 20.5435 28.1957 20.3477 28.4375 20.3477H55.5625C55.8043 20.3477 56 20.5435 56 20.7852C56 21.0268 55.8043 21.2227 55.5625 21.2227Z",
    fill: "#C3DDFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6875 20.7851L76.5419 10.5424C76.3067 10.1504 75.8092 10.0055 75.4003 10.21L74.6571 10.5816C74.4886 10.6658 74.2852 10.6328 74.152 10.4996L70.6861 7.03363C70.3192 6.66673 69.7154 6.69791 69.3882 7.10057L60.375 18.1601V20.7851H82.6875Z",
    fill: "#DBEAFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.657 10.5817C74.4886 10.6659 74.2851 10.6329 74.152 10.4997L74.0222 10.3699L71.0117 20.6624L71.4317 20.7852H71.8876L74.909 10.4557L74.657 10.5817Z",
    fill: "#C3DDFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 14.2226L70.3866 6.83738C70.0441 6.70334 69.6366 6.79489 69.3882 7.10054L60.375 18.1601V20.7851H66.5V14.2226Z",
    fill: "#C3DDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6871 12.5238C69.3631 12.2421 68.8826 12.237 68.5527 12.5119L66.5 14.2226L64.0583 13.1761C63.6926 13.0193 63.2671 13.1291 63.0229 13.4431L57.3125 20.7851H79.1875L69.6871 12.5238Z",
    fill: "#C3DDFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0583 13.176C63.6926 13.0193 63.2671 13.1291 63.0229 13.4431L57.3125 20.785H69.5625L66.5 14.2225L64.0583 13.176Z",
    fill: "#A4CCFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0583 13.176C63.6926 13.0193 63.2671 13.1291 63.0229 13.4431L57.3125 20.785H60.8125L64.851 13.5158L64.0583 13.176Z",
    fill: "#8BB3EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5625 21.2227H56.4375C56.1957 21.2227 56 21.0268 56 20.7852C56 20.5435 56.1957 20.3477 56.4375 20.3477H83.5625C83.8043 20.3477 84 20.5435 84 20.7852C84 21.0268 83.8043 21.2227 83.5625 21.2227Z",
    fill: "#C3DDFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced);
export default __webpack_public_path__ + "static/media/advanced.73e078c0.svg";
export { ForwardRef as ReactComponent };